const AppConfig = {
    // baseUrl: 'http://localhost:4001',
    // baseUrl: 'https://lt-api.infiny.dev'
    // baseUrl: 'https://api.leasejava.com'
    baseUrl: 'https://demo-api.leasejava.com'
    // baseUrl: 'https://api.leasevista.com'
    // baseUrl: 'https://demo-api.leasevista.com'
}
  
export default AppConfig;